export default {
  getBucketParameter(state){
    return state.bucketParameter
  },
  getResourcePrefix(state){
    return state.resourcePrefix
  },
  getRefresh(state){
    return state.refresh
  }
}



// WEBPACK FOOTER //
// ./src/store/common/getters.js